var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-dialog',{ref:"dialog",attrs:{"width":"500"},on:{"resolve":_vm.editHandle}},[_c('c-form',{ref:"form",attrs:{"vertical":"","unit-width":"100%"}},[_c('c-input',{attrs:{"type":"hidden","name":"id"}}),_c('c-form-item',{attrs:{"label":"数据权限","required":""}},[_c('c-radio-group',{attrs:{"name":"data_scope","options":_vm.dataScopeDic}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }